import * as THREE from 'three';

export function createInfillLines(infillSegments, height = 0, color = 0xffaa00) {
  const geometry = new THREE.BufferGeometry();
  const positions = [];

  infillSegments.forEach(([p1, p2]) => {
    positions.push(p1.x, height, p1.z);
    positions.push(p2.x, height, p2.z);
  });

  geometry.setAttribute('position', new THREE.Float32BufferAttribute(positions, 3));
  const material = new THREE.LineBasicMaterial({ color });
  return new THREE.LineSegments(geometry, material);
}
